import { __, addIntlData } from 'first-intl';
import React, { Component, useState, useCallback, forwardRef, createElement } from 'react';
import { A, ClientNavigation, LoadingScreen, TrackingForm, FormInput, FormDatePicker, RequiredInfo, FormCheckbox, DisplayError, FormButtons, Button, Toaster, Validators, Modal } from '@hugendubel/react-basic';
import { WsValidators, FormSalutationPicker } from '@hugendubel/react-ws';
import { TRACK_ID, Track } from '@hugendubel/tracking_manager';
import { createCall, WsTokenPair, Method, VoidParser, createCustomerCall, TokenChecks, WsClient, TokenStore, CustomerStore, WsCustomer, Fetcher, WsErrorCode, AdCodeStore } from '@hugendubel/ws_client';
import { LocationUtil, UrlUtil, AppPath, DateUtil } from '@hugendubel/utils';
import { Cart } from '@hugendubel/cart';
import { Persistore } from 'persistore';
import { useHref, useLocation, useResolvedPath, useNavigate, createPath } from 'react-router';

var intlData = {
	"button.back": "Zurück",
	"createAccount.title": "Neues Konto einrichten",
	"createAccount.title.accessData": "Ihre Zugangsdaten",
	"createAccount.firstName": "Vorname",
	"createAccount.lastName": "Nachname",
	"createAccount.email": "E-Mail-Adresse {info}",
	"createAccount.emailReserved": "Diese E-Mail ist bereits registriert.",
	"createAccount.invalidEmail": "Die angegebene E-Mail ist ungültig.",
	"createAccount.password": "Passwort {info}",
	"createAccount.passwordRepeat": "Passwort wiederholen",
	"createAccount.email.info": "(wird als Benutzername verwendet)",
	"createAccount.password.info": "(mindestens 6-stellig, mindestens eine Zahl und ein Buchstabe)",
	"createAccount.passwordContainsEmail": "Das Passwort darf nicht Teile der E-Mail enthalten.",
	"createAccount.passwordTooShort": "Das Passwort ist zu kurz.",
	"createAccount.newsletter.title": "Highlight-Newsletter",
	"createAccount.newsletter.label.hudu": "Ja, ich abonniere gerne den kostenlosen Newsletter von Hugendubel.de (insbesondere mit Informationen über Neuerscheinungen, Aktionen, Gewinnspielen, eigenen Angeboten oder Angeboten von Partnerfirmen und Aktionen und Veranstaltungen der unter der Heinrich Hugendubel GmbH & Co KG geführten Filialen). Den Newsletter kann ich jederzeit wieder abbestellen.{br}Sie erhalten im Anschluss zusätzlich eine E-Mail, in der Sie gebeten werden, die Newsletter-Bestellung durch den Klick auf einen Aktivierungslink zu bestätigen.",
	"createAccount.newsletter.label.ebook": "Ja, ich abonniere gerne den kostenlosen Newsletter von eBook.de (insbesondere mit Informationen über Neuerscheinungen, Aktionen, Gewinnspielen, eigenen Angeboten oder Angeboten von Partnerfirmen und Aktionen.). Den Newsletter kann ich jederzeit wieder abbestellen.{br}Sie erhalten im Anschluss zusätzlich eine E-Mail, in der Sie gebeten werden, die Newsletter-Bestellung durch den Klick auf einen Aktivierungslink zu bestätigen.",
	"createAccount.recommendations.title": "Produktempfehlungen",
	"createAccount.recommendations.label.hudu": "Ja, ich wünsche die Anzeige personalisierter Inhalte (z.B. Produktempfehlungen, Bannerausspielung, Veranstaltungen in Filialen) auf Hugendubel.de, in werblichen E-Mails oder das Nutzen dieser Informationen in Gesprächen mit den Mitarbeitern der von der Heinrich Hugendubel GmbH & Co geführten Filialen. Diese Inhalte dürfen auf meinem Surfverhalten auf Hugendubel.de sowie meinem Umgang mit Werbeemails von Hugendubel.de und meinen Käufen in den von der Heinrich Hugendubel GmbH & Co KG geführten Filialen basieren. Weitere Informationen und Abmeldemöglichkeiten finden Sie in der {dpp}.",
	"createAccount.recommendations.label.hudu.ddp.oauth": "Datenschutzerklärung unter: https://www.hugendubel.de/datenschutz",
	"createAccount.recommendations.label.ebook": "Ja, ich wünsche die Anzeige personalisierter Inhalte (z.B. Produktempfehlungen oder Bannerausspielung) auf eBook.de oder in werblichen E-Mail. Diese Inhalte dürfen auf meinem Surfverhalten auf eBook.de sowie meinem Umgang mit Werbeemails von eBook.de basieren. Weitere Informationen und Abmeldemöglichkeiten finden Sie in der {dpp}.",
	"createAccount.recommendations.label.ebook.ddp.oauth": "Datenschutzerklärung unter: https://www.ebook.de/datenschutz",
	"createAccount.ebookBonusProgram.title": "Prämienprogramm",
	"createAccount.ebookBonusProgram.label": "Ja, ich möchte am Prämienprogramm teilnehmen. Mit meiner Anmeldung sichere ich mir 200 Prämienpunkte als Startguthaben. Mit jeder Bestellung ab einem Bestellwert von 30 EUR sammle ich Prämienpunkte, die ich auf ausgewählte Produkte einlösen kann. Mehr Infos und die Teilnahmebedingungen finden Sie unter: {infoLink}.",
	"createAccount.ebookBonusProgram.infoLink.label": "hier",
	"createAccount.submit": "Weiter",
	"createAccount.general.error": "Leider ist die Registrierung fehlgeschlagen. Bitte versuchen Sie es später noch einmal.",
	"createAccount.birthday": "Geburtsdatum",
	"createAccount.emailAdvertise.info": "Wir werden Ihnen Werbung zu ähnlichen Produkten oder Dienstleistungen aus unserem Sortiment per E-Mail zusenden.{br}Sie können der Verwendung Ihrer Daten jederzeit z.B. mittels der in den E-Mails enthaltenen Abmeldelinks widersprechen, ohne dass hierfür andere als die Übermittlungskosten nach den Basistarifen entstehen. Weitere Informationen dazu finden Sie in unserer {dpp}.",
	"data.privacy.policy": "Datenschutzerklärung",
	"forgotPw.email.label": "E-Mail-Adresse",
	"forgotPw.modal.header": "Sie haben Ihr Passwort vergessen?",
	"forgotPw.info": "Bitte E-Mail-Adresse eingeben, um einen Link zum Zurücksetzen des Passworts zu erhalten.",
	"forgotPw.infoSubmitted": "Wir haben eine E-Mail mit Instruktionen zum Zurücksetzen des Passworts an die angegebene Adresse geschickt.",
	"forgotPw.submit.button": "Absenden",
	"forgotPw.general.error": "Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
	"forgotPw.invalidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
	"loading.logout": "Sie werden abgemeldet.",
	"login.headline": "Kunden-Login",
	"login.email.label": "E-Mail-Adresse",
	"login.password.label": "Passwort",
	"login.password.repeat.label": "Passwort wiederholen",
	"login.password.error": "Bitte geben Sie ein Passwort ein.",
	"login.passwordForgotten.link": "Passwort vergessen",
	"login.submit.button": "Anmelden",
	"login.authentication.failed": "Leider ist der Login fehlgeschlagen. Bitte prüfen Sie, ob Sie E-Mail-Adresse und Passwort korrekt eingegeben haben.",
	"login.general.error": "Leider ist der Login fehlgeschlagen. Bitte versuchen Sie es später noch einmal.",
	"LoginPage.headline": "Neu bei {brandname}",
	"LoginPage.benefit1": "Bequem bestellen",
	"LoginPage.benefit2": "Bestellungen einsehen",
	"LoginPage.benefit3": "Adressen und Zahldaten verwalten",
	"LoginPage.benefit4": "Auf Ihre eBooks zugreifen",
	"LoginPage.benefit5": "Artikel auf Merkzettel setzen",
	"LoginPage.submit.button": "Konto einrichten"
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$1.apply(this, arguments);
}

const ValidationTypes = ['onChange', 'onBlur', 'onSubmit'];

const isPromise = obj => Boolean(obj && typeof obj.then === 'function');

const validateField = (field, validator) => {
  return validator && validator(field);
};

const completeFieldValidation = (field, validators) => {
  const promises = [];
  let syncError;
  ValidationTypes.forEach(validationType => {
    if (!syncError) {
      const error = validateField(field, validators[validationType]);

      if (error) {
        if (isPromise(error)) {
          promises.push(error);
        } else {
          syncError = error;
        }
      }
    }
  });

  if (syncError) {
    return syncError;
  }

  if (promises.length > 0) {
    return new Promise(resolve => {
      Promise.all(promises).then(results => {
        resolve(results.find(Boolean));
      });
    });
  }
};

const copyData = data => {
  return {
    values: _objectSpread2({}, data.values),
    errors: _objectSpread2({}, data.errors),
    submitting: data.submitting
  };
};

class MorfiError extends Error {
  constructor(m, ...params) {
    super(m, ...params);
    Error.captureStackTrace && Error.captureStackTrace(this, MorfiError);
    this.name = 'MorfiError';
  }

}
const FormUtil = {
  isPromise,
  setSubmitting: (oldData, submitting) => {
    const result = copyData(oldData);
    result.submitting = submitting;
    return result;
  },
  update: (oldData, fieldId, value, error) => {
    const result = copyData(oldData);
    result.values[fieldId] = value;
    result.errors[fieldId] = error;
    return result;
  },
  validateField,
  completeFieldValidation,
  validateAll: (data, validation) => {
    const copy = copyData(data);
    const promises = [];
    Object.keys(validation).forEach(fieldId => {
      const error = completeFieldValidation(data.values[fieldId], validation[fieldId]);

      if (error) {
        if (isPromise(error)) {
          promises.push(error.then(err => {
            if (err) {
              copy.errors[fieldId] = err;
            }
          }));
        } else {
          copy.errors[fieldId] = error;
        }
      }
    });

    if (promises.length > 0) {
      return new Promise(resolve => {
        Promise.all(promises).then(() => resolve(copy));
      });
    }

    return copy;
  },
  hasErrors: data => Object.keys(data.errors).filter(key => data.errors[key] !== undefined).length > 0,
  isRequired: validators => {
    return !!validators && Boolean(completeFieldValidation(undefined, validators));
  },

  isValidationError(err) {
    return err instanceof Error && err.name === 'MorfiError';
  }

};

let Form$3 = class Form extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "update", (name, value, type) => {
      const {
        data,
        validation
      } = this.props;
      const validators = validation[name];
      const validator = validators ? validators[type] : undefined;
      const error = FormUtil.validateField(value, validator);

      if (FormUtil.isPromise(error)) {
        if (data.values[name] !== value) {
          this._onFieldChangeAfterValidation(name, value, undefined);
        }

        error.then(e => {
          if (this.props.data.values[name] === value) {
            this._onFieldChangeAfterValidation(name, value, e);
          }
        });
      } else {
        this._onFieldChangeAfterValidation(name, value, error);
      }
    });

    _defineProperty(this, "_onFieldChangeAfterValidation", (name, nextValue, nextError) => {
      const {
        data
      } = this.props;

      if (data.values[name] !== nextValue || nextError && !data.errors[name]) {
        this._onChange(FormUtil.update(data, name, nextValue, nextError));
      }
    });

    _defineProperty(this, "required", name => FormUtil.isRequired(this.props.validation[name]));

    _defineProperty(this, "_onSubmit", event => {
      event.preventDefault();
      const data = this.props.data;

      this._onChange(FormUtil.setSubmitting(data, true));

      const validated = FormUtil.validateAll(data, this.props.validation);

      if (FormUtil.isPromise(validated)) {
        validated.then(validatedData => {
          this._onSubmitAfterValidation(validatedData);
        });
      } else {
        this._onSubmitAfterValidation(validated);
      }
    });

    _defineProperty(this, "_onSubmitAfterValidation", data => {
      if (!FormUtil.hasErrors(data)) {
        const maybePromise = this.props.onSubmit(data.values);

        if (FormUtil.isPromise(maybePromise)) {
          maybePromise.then(this._finishSubmit).catch(e => {
            const nextData = FormUtil.setSubmitting(this.props.data, false);

            this._onChange(nextData);

            this._onSubmitFailed(e, nextData);
          });
        } else {
          this._finishSubmit();
        }
      } else {
        data.submitting = false;

        this._onChange(data);

        this._onSubmitFailed(new MorfiError('validation failed'), data);
      }
    });

    _defineProperty(this, "_finishSubmit", () => {
      const nextData = FormUtil.setSubmitting(this.props.data, false);

      this._onChange(nextData);

      this._onSubmitFinished(nextData);
    });

    _defineProperty(this, "_onChange", data => {
      if (this.m) this.props.onChange(data);
    });

    _defineProperty(this, "_onSubmitFailed", (e, data) => {
      const {
        onSubmitFailed
      } = this.props;
      if (this.m && onSubmitFailed) onSubmitFailed(e, data);
    });

    _defineProperty(this, "_onSubmitFinished", data => {
      const {
        onSubmitFinished
      } = this.props;
      if (this.m && onSubmitFinished) onSubmitFinished(data);
    });

    _defineProperty(this, "m", true);
  }

  componentWillUnmount() {
    this.m = false;
  }

  render() {
    const {
      className,
      children,
      data,
      FC,
      forwardRef
    } = this.props;
    return React.createElement("form", {
      className: className,
      onSubmit: this._onSubmit,
      method: "post",
      ref: forwardRef
    }, React.createElement(FC.Provider, {
      value: {
        data,
        update: this.update,
        required: this.required
      }
    }, children));
  }

};

const Field = ({
  value,
  error,
  name,
  children,
  update,
  required
}) => {
  return children({
    onChange: v => update(name, v, 'onChange'),
    onBlur: v => update(name, v, 'onBlur'),
    value,
    error,
    required: required(name)
  });
};

const makeField = (name, FC) => {
  const FieldUpdater = p => React.createElement(FC.Consumer, null, ({
    data,
    update,
    required
  }) => React.createElement(Field, {
    name: name,
    update: update,
    required: required,
    value: data.values[name],
    error: data.errors[name]
  }, p.children));

  return FieldUpdater;
};

const makeForm = FC => {
  const FormUpdater = p => React.createElement(Form$3, _extends$1({}, p, {
    FC: FC
  }));

  return FormUpdater;
};

const create = initial => {
  const FC = React.createContext({
    data: {
      values: initial,
      errors: {}
    }
  });
  const Form = makeForm(FC);
  const Fields = Object.keys(initial).reduce((r, name) => {
    r[name] = makeField(name, FC);
    return r;
  }, {});
  return {
    Form,
    Fields
  };
};

const Morfi = {
  create,
  hasErrors: FormUtil.hasErrors,
  isValidationError: FormUtil.isValidationError
};

const LoginLinks = {
    DATA_PRIVACY: '/datenschutz',
    EBOOK_BONUS_PROGRAM: '/bonusprogramm',
};

const EmailAdvertiseInfo = ({ isOauth }) => (React.createElement("fieldset", null,
    React.createElement("div", { className: "message" }, __({
        id: 'createAccount.emailAdvertise.info',
        values: {
            br: React.createElement("br", null),
            dpp: isOauth ? (process.env.IS_HUDU ? (__('createAccount.recommendations.label.hudu.ddp.oauth')) : (__('createAccount.recommendations.label.ebook.ddp.oauth'))) : (React.createElement(A, { trackId: TRACK_ID('2018-08-22 03:51:18'), href: LoginLinks.DATA_PRIVACY, external: true }, __('data.privacy.policy'))),
        },
    }))));

const Globals = {
    window: () => window,
    origin: () => window.location.origin,
};

const LANGUAGE_CODE = 'de';
const WS = {
    authentication: {
        customerLoginJwt: createCall({
            name: 'authentication/customerloginjwt',
            parser: WsTokenPair.parse,
            method: Method.POST,
        }),
    },
    customer: {
        register: createCall({
            name: 'customer/register',
            parser: VoidParser,
            method: Method.POST,
        }),
    },
    guest: {
        login: createCall({
            name: 'customer/createguest',
            parser: WsTokenPair.parse,
            method: Method.POST,
        }),
    },
    newsletter: {
        subscribe: createCustomerCall({
            name: 'newsletter/subscribe',
            parser: VoidParser,
            method: Method.POST,
        }),
    },
    oneTimeToken: {
        createPasswordResetToken: createCall({
            name: 'onetimetoken/createpasswordresettoken',
            parser: VoidParser,
        }),
    },
};

const _SessionKeepAlive = {
    outsideIFrame: Globals.window() === Globals.window().top,
};
/**
 * The following lines are keeping alive the PC-Shop-Session by calling on every
 * token refresh a PC-Shop-action which returns no content.
 *
 * Since this keep alive will only be triggered on token refresh
 * we keep the session only alive if he is active in the bonus shop.
 */
let __keep_alive_counter = 0;
const run = () => {
    process.env.NODE_ENV !== 'development' &&
        _SessionKeepAlive.outsideIFrame &&
        Globals.window().fetch(`/de/account/bonus/loyalty/keep-alive?${__keep_alive_counter++}`);
};
const SessionKeepAlive = { run };

const NOP = () => { };
const BOOKSHOP_LOGIN_URL = '/de/auth/login';
const BOOKSHOP_LOGOUT_URL = '/de/account/logout';
const _AuthService = {};
// this state will indicate if the call to the "onUpdate" callback needs to be postponed
// since a cart merge has to be done because the user used the login / registration
_AuthService.cartNeedsMerge = false;
// configurable
_AuthService.isLoggedIn = TokenChecks.isCustomer;
_AuthService.cleanUpNoAuth = NOP;
_AuthService.cleanUpFromAuth = NOP;
_AuthService.onUpdate = NOP;
_AuthService.fullLogout = true;
const configure = ({ isLoggedIn, cleanUpNoAuth, cleanUpFromAuth, onUpdate, fullLogout }) => {
    isLoggedIn && (_AuthService.isLoggedIn = isLoggedIn);
    cleanUpNoAuth && (_AuthService.cleanUpNoAuth = cleanUpNoAuth);
    cleanUpFromAuth && (_AuthService.cleanUpFromAuth = cleanUpFromAuth);
    onUpdate && (_AuthService.onUpdate = onUpdate);
    fullLogout !== undefined && (_AuthService.fullLogout = fullLogout);
};
_AuthService.bookshopLogin = (accessToken, email, password) => process.env.NODE_ENV !== 'development' && !TokenStore.isTemporarySession()
    ? Globals.window()
        .fetch(BOOKSHOP_LOGIN_URL, {
        method: Method.POST,
        headers: Fetcher.headers({ auth: accessToken, encoding: true }),
        body: UrlUtil.queryToString({ username: email, password }),
    })
        .then(() => { }) // response does not matter
        .catch(e => {
        Track.error(TRACK_ID('2019-06-12 10:20:39'), 'Could not login with bookshop session, because: ' + e.message);
    })
    : Promise.resolve();
_AuthService.finishBookshopLogin = (token, email, password, redirectPath, isRegistration) => 
// we need to first login with bookshop session, because:
// when calling "WsClient.Controller.update(token);" (see below)
// we might get forwarded to the LastCheck-Page, BUT this one would redirect
// us to the cart page (if the anonymous (without merge) basket was empty)
// FINALLY the cart page is part of the bookshop, where we need to be logged in
_AuthService
    .bookshopLogin(token.accessToken, email, password)
    .then(() => _AuthService.finishLogin(token, redirectPath, isRegistration));
_AuthService.finishMobileShopLogin = (token, redirectPath, isRegistration) => {
    // we need to clear the previous login state for the current session
    // else the mobile shop won't load the customer data and still assume
    // that the current user has only anonymous access
    Persistore.session.remove('koala-login-state');
    // we have to set any here because window is now typed as Window
    // but we can't deal with this type here as the destructured function
    // represents a callback from the mobile-shop
    const { tryToLoginWithCurrentTokens } = Globals.window();
    if (tryToLoginWithCurrentTokens && !TokenStore.isTemporarySession()) {
        tryToLoginWithCurrentTokens(token.accessToken, token.refreshToken);
    }
    return _AuthService.finishLogin(token, redirectPath, isRegistration);
};
_AuthService.finishLogin = (tokenPair, redirectPath, isRegistration) => {
    _AuthService.cartNeedsMerge = true;
    return WsClient.Controller.update(tokenPair).then(() => {
        if (redirectPath) {
            const actualRedirectPath = (redirectPath === null || redirectPath === void 0 ? void 0 : redirectPath.startsWith('/')) ? redirectPath : '/' + redirectPath;
            LocationUtil.redirect(Globals.window().location.protocol + '//' + Globals.window().location.hostname + actualRedirectPath);
        }
        // TODO(MW): This is a temp fix to make the jsp update of the login status part of the bookshop header work. However,
        // it did cause the problem that anonymous customer's cart items wouldn't be merged, because the state of
        // _AuthService.cartNeedsMerge is lost on page reload. To settle both cases, we are only forcing a reload here, for
        // the customer app. The server side rendered nature of the bookshop makes an update of the logged-in-status in the
        // header very difficult otherwise. This should be deleted with the bookshop.
        // Notice that the reload is only needed if the login is not triggered from the register function
        // as the registration already triggers a redirect to the confirmation page, which updates the header as well
        if (!redirectPath && AppPath.matchesCurrentLocation(AppPath.appPaths.CUSTOMER) && !isRegistration) {
            LocationUtil.reload();
        }
    });
};
const login = (email, password, redirectPath, isRegistration) => WS.authentication
    .customerLoginJwt({
    username: email,
    password,
})
    .then((token) => {
    _AuthService.finishBookshopLogin(token, email, password, redirectPath, isRegistration);
});
const register = (params, subscribeToNewsletter, confirmationPath) => WS.customer
    .register(params)
    .then(() => AuthService.login(params.email, params.password, undefined, true))
    .then(() => {
    if (subscribeToNewsletter) {
        // we do not wait for the subscription result but do in the background
        // while the user proceeds to wherever he wants to go
        WS.newsletter.subscribe().catch(e => {
            Track.error(TRACK_ID('2019-02-19 08:00:07'), 'Newsletter subscription failed: ' + e.message);
        });
    }
    if (confirmationPath) {
        const path = Globals.origin() + '/de/account' + confirmationPath;
        LocationUtil.redirect(path);
    }
});
/**
 * ATTENTION: The error handling is done inside the guest registration component.
 *            Mainly because the error corresponding to some invalid email address
 *            should be displayed inside the form.
 */
const registerGuest = (params) => WS.guest.login(params).then(WsClient.Controller.updateSession);
const pushToLogoutPage = () => ClientNavigation.open(BOOKSHOP_LOGOUT_URL);
const logout = () => {
    WsClient.Controller.logout();
    if (_AuthService.fullLogout) {
        LoadingScreen.open('loading.logout');
        AuthService.pushToLogoutPage();
    }
};
const isLoggedIn = () => _AuthService.isLoggedIn(WsClient.Controller.getToken());
/**
 * When called this basically indicates that the client was forced to remove the tokens
 * due to expired or invalid token.
 *
 * If this happens we will get very soon a new anonymous token.
 * There are 2 cases we want to distinguish:
 * 1) An anonymous token has expired -> nothing to do
 * 2) An customer token has expired -> We need to clear all customer related data and performs a complete logout
 */
const onWsClientLogout = (prevToken) => {
    if (_AuthService.isLoggedIn(prevToken)) {
        AuthService.logout();
    }
};
/**
 * When called this basically indicates that the client did update the access token.
 *
 * This can happen for several reasons (we want to distinguish):
 * 1 ) The client had no token and then received one (-> anonymous login)
 * 2 ) The client had an anonymous token but lost it (-> they were deleted externally)
 * 3*) The client had a customer token but lost it (-> they were deleted externally)
 * 4*) The client token changed from customer to anonymous (was logged out in a different tab)
 * 5 ) The client token changed from anonymous to customer (the login happened)
 * 6*) The client token changed from one customer to a different customer (externally logged in with different account)
 */
const onWsClientUpdate = (prevToken, token) => {
    SessionKeepAlive.run();
    // For this context, a customer is authenticated if they have limited customer access
    // This does not hold for all cases, but here we handle data that should be loaded for limited customer access
    // (and deleted if it is not required anymore)
    // if we are currently in a temporary session, ignore the previous token and pretend we were not logged in
    const wasAuthenticated = !TokenStore.isTemporarySession() &&
        (_AuthService.isLoggedIn(prevToken) || TokenChecks.isLimitedCustomerAccess(prevToken));
    const authenticated = _AuthService.isLoggedIn(token) || TokenChecks.isLimitedCustomerAccess(token);
    if (!authenticated)
        _AuthService.cleanUpNoAuth();
    if (wasAuthenticated) {
        if (!authenticated) {
            // case 3 or 4 -> we need to remove the session storage because the
            // rest should have been already removed wherever the logout took place
            Globals.window().sessionStorage.clear();
            // and then perform the custom clean up of that special UI
            _AuthService.cleanUpFromAuth();
        }
        else {
            // the user was authenticated and is authenticated -> hence both tokens are non-maybe-types
            if (prevToken.customerId !== token.customerId) {
                // case 6 -> we need to remove the session storage AND basically load all data again
                Globals.window().sessionStorage.clear();
                // TODO(VL): the better behaviour would be:
                //           -> doing nothing more on cart page / in iFrame
                //           -> reload the data while showing a spinner on LastCheckPage
                //           -> redirect to cart page when on order confirmation page
                //           But for now we will only refresh the page
                ClientNavigation.open(Globals.window().location.href);
                return Promise.resolve();
            }
        }
    }
    // we do not want to touch any customer state in a temporary session
    if (!TokenStore.isTemporarySession()) {
        return CustomerStore.update(authenticated).then(customer => {
            if (customer) {
                Track.loggedInCustomer(TRACK_ID('2019-12-12 10:27:05'), WsCustomer.toTrackingCustomer(customer));
            }
            else {
                Track.loggedOutCustomer(TRACK_ID('2019-12-17 14:40:37'));
            }
            if (authenticated && _AuthService.cartNeedsMerge) {
                _AuthService.cartNeedsMerge = false;
                return Cart.mergeAtLoginAndUpdate().then(() => _AuthService.onUpdate(authenticated, token, customer));
            }
            else {
                return Promise.resolve(_AuthService.onUpdate(authenticated, token, customer));
            }
        });
    }
    else {
        return Promise.resolve(_AuthService.onUpdate(authenticated, token, undefined));
    }
};
const AuthService = {
    logout,
    login,
    register,
    registerGuest,
    pushToLogoutPage,
    isLoggedIn,
    onWsClientLogout,
    onWsClientUpdate,
    configure,
};

const initialValues$2 = {
    salutation: undefined,
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordRepeat: '',
    newsletter: false,
    recommendations: false,
    birthday: { date: undefined, valid: true },
    ebookBonusProgram: false,
    confirmationPath: '',
};
const { Form: Form$2, Fields: Fields$2 } = TrackingForm.create(initialValues$2, TRACK_ID('2019-03-12 10:03:31'));
const staticValidation = {
    salutation: { onBlur: WsValidators.salutation },
    firstName: { onChange: WsValidators.firstName },
    lastName: { onChange: WsValidators.lastName },
    email: { onChange: WsValidators.emailChange, onBlur: WsValidators.email },
    password: { onChange: WsValidators.passwordChange, onBlur: WsValidators.password },
    birthday: { onSubmit: WsValidators.datePickerResult },
};
const WS_ERROR_MAP = {
    [WsErrorCode.CUSTOMER_USERNAME_NOT_UNIQUE]: { email: { id: 'createAccount.emailReserved' } },
    [WsErrorCode.PASSWORD_TOO_SIMPLE_USERNAME]: { password: { id: 'createAccount.passwordContainsEmail' } },
    [WsErrorCode.PASSWORD_TOO_SIMPLE_MIN_LENGTH]: { password: { id: 'createAccount.passwordTooShort' } },
    [WsErrorCode.INVALID_EMAIL_ADDRESS]: { email: { id: 'createAccount.invalidEmail' } },
};
const onSubmit$1 = ({ salutation, // validation ensures that it was always selected
firstName, lastName, email, password, newsletter, recommendations, birthday, ebookBonusProgram, confirmationPath, }) => {
    const adCodeExtra = AdCodeStore.getExtraParam();
    const { name, value } = adCodeExtra || {};
    return AuthService.register({
        email,
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        password,
        salutation: salutation,
        myshopFlag: recommendations,
        birthDate: birthday && birthday.date && birthday.valid ? DateUtil.toWsApiString(birthday.date) : undefined,
        bonusProgram: process.env.IS_HUDU ? undefined : ebookBonusProgram,
        adCode: AdCodeStore.get(),
        adCodeExtraParamName: name,
        adCodeExtraParamValue: value,
    }, newsletter, confirmationPath);
};
const CreateAccountForm = ({ cancel, isOauthReg, confirmationPath }) => {
    const [formData, setFormData] = useState({ values: initialValues$2, errors: {} });
    const [showError, setShowError] = useState(false);
    const repetitionValidator = (v) => {
        if (v !== formData.values.password) {
            return { id: 'validation.pw.repetition' };
        }
    };
    const validation = { ...staticValidation, passwordRepeat: { onChange: repetitionValidator } };
    const onChange = (nextData) => {
        if (formData.values.password !== nextData.values.password) {
            delete nextData.errors.passwordRepeat;
        }
        //adding the confirmationPath form the props to the newData
        if (confirmationPath) {
            nextData.values.confirmationPath = confirmationPath;
        }
        setFormData(nextData);
        setShowError(false);
    };
    const onSubmitFailed = (error) => {
        if (!Morfi.isValidationError(error)) {
            const { errorCode } = error;
            const errors = errorCode && WS_ERROR_MAP[errorCode];
            if (errors) {
                setFormData({ ...formData, errors: { ...formData.errors, ...errors } });
            }
            else {
                setShowError(true);
            }
        }
    };
    const { submitting } = formData;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "container-fluid" },
            React.createElement("h2", null, __('createAccount.title')),
            React.createElement(Form$2, { className: "createAccount fullwidth", data: formData, validation: validation, onSubmitFailed: onSubmitFailed, onSubmit: onSubmit$1, onChange: onChange },
                React.createElement("fieldset", { className: "row" },
                    React.createElement("div", { className: "col col-xs-12 col-sm-6" },
                        React.createElement("legend", null, __('createAccount.title.accessData')),
                        React.createElement(FormSalutationPicker, { Field: Fields$2.salutation, name: "salutation" }),
                        React.createElement(FormInput, { Field: Fields$2.firstName, name: "firstName", label: "createAccount.firstName", autocomplete: "given-name" }),
                        React.createElement(FormInput, { Field: Fields$2.lastName, name: "lastName", label: "createAccount.lastName", autocomplete: "family-name" }),
                        React.createElement(FormInput, { Field: Fields$2.email, name: "email", label: {
                                id: 'createAccount.email',
                                values: {
                                    info: React.createElement("span", { className: "form-info" }, __('createAccount.email.info')),
                                },
                            }, autocomplete: "email", trim: true }),
                        React.createElement(FormInput, { Field: Fields$2.password, name: "password", type: "password", label: {
                                id: 'createAccount.password',
                                values: {
                                    info: React.createElement("span", { className: "form-info" }, __('createAccount.password.info')),
                                },
                            }, autocomplete: "new-password" }),
                        React.createElement(FormInput, { Field: Fields$2.passwordRepeat, name: "passwordRepeat", type: "password", label: "createAccount.passwordRepeat" }),
                        React.createElement(FormDatePicker, { Field: Fields$2.birthday, label: "createAccount.birthday" }),
                        React.createElement(RequiredInfo, null))),
                React.createElement(EmailAdvertiseInfo, { isOauth: isOauthReg }),
                !isOauthReg && (React.createElement("fieldset", null,
                    React.createElement("legend", null, __('createAccount.newsletter.title')),
                    React.createElement(FormCheckbox, { Field: Fields$2.newsletter, name: "newsletter", className: "small-text", label: {
                            id: process.env.IS_HUDU
                                ? 'createAccount.newsletter.label.hudu'
                                : 'createAccount.newsletter.label.ebook',
                            values: { br: React.createElement("br", null) },
                        } }))),
                React.createElement("fieldset", null,
                    React.createElement("legend", null, __('createAccount.recommendations.title')),
                    React.createElement(FormCheckbox, { Field: Fields$2.recommendations, name: "recommendations", className: "small-text", label: {
                            id: process.env.IS_HUDU
                                ? 'createAccount.recommendations.label.hudu'
                                : 'createAccount.recommendations.label.ebook',
                            values: {
                                dpp: isOauthReg ? (process.env.IS_HUDU ? (__('createAccount.recommendations.label.hudu.ddp.oauth')) : (__('createAccount.recommendations.label.ebook.ddp.oauth'))) : (React.createElement(A, { trackId: TRACK_ID('2018-08-22 03:51:18'), href: LoginLinks.DATA_PRIVACY, external: true }, __('data.privacy.policy'))),
                            },
                        } })),
                !process.env.IS_HUDU && (React.createElement("fieldset", null,
                    React.createElement("legend", null, __('createAccount.ebookBonusProgram.title')),
                    React.createElement(FormCheckbox, { Field: Fields$2.ebookBonusProgram, name: "ebookBonusProgram", className: "small-text", label: {
                            id: 'createAccount.ebookBonusProgram.label',
                            values: {
                                infoLink: isOauthReg ? ('https://www.ebook.de' + LoginLinks.EBOOK_BONUS_PROGRAM) : (React.createElement(A, { trackId: TRACK_ID('2019-05-14 01:19:01'), href: LoginLinks.EBOOK_BONUS_PROGRAM, external: true }, __('createAccount.ebookBonusProgram.infoLink.label'))),
                            },
                        } }))),
                showError && React.createElement(DisplayError, { error: "createAccount.general.error" }),
                React.createElement(FormButtons, { onAbort: cancel, submitLabel: "createAccount.submit", abortLabel: "button.back", disabled: Morfi.hasErrors(formData) || showError, loading: submitting })))));
};

const CreateAccountOpportunity = ({ enterRegistration }) => (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "h2" }, __({
        id: 'LoginPage.headline',
        values: {
            brandname: process.env.IS_HUDU ? 'Hugendubel.de' : 'eBook.de',
        },
    })),
    React.createElement("ul", { className: "benefit" },
        React.createElement("li", null, __('LoginPage.benefit1')),
        React.createElement("li", null, __('LoginPage.benefit2')),
        React.createElement("li", null, __('LoginPage.benefit3')),
        React.createElement("li", null, __('LoginPage.benefit4')),
        React.createElement("li", null, __('LoginPage.benefit5'))),
    React.createElement("div", { className: "buttons" },
        React.createElement(Button, { type: "button", className: "btn btn-primary btn-lg", onClick: enterRegistration, label: "LoginPage.submit.button" }))));

const initialValues$1 = { email: '' };
const _PasswordForgottenForm = {};
_PasswordForgottenForm.onSubmit = ({ email }) => WS.oneTimeToken.createPasswordResetToken({ email, languageCode: LANGUAGE_CODE });
const { Form: Form$1, Fields: Fields$1 } = TrackingForm.create(initialValues$1, TRACK_ID('2019-03-12 10:15:28'));
const validation = { email: { onSubmit: WsValidators.email, onChange: WsValidators.email } };
const PasswordForgottenForm = ({ close, email = '' }) => {
    const [data, setData] = useState({
        values: { email },
        errors: {},
    });
    const onSubmitFinished = useCallback(() => {
        Toaster.open({ id: 'forgotPw.infoSubmitted' });
        close();
    }, [close]);
    const onSubmitFailed = useCallback((error) => {
        if (!Morfi.isValidationError(error)) {
            if (error.errorCode === WsErrorCode.INVALID_EMAIL_ADDRESS) {
                setData(prev => ({
                    ...prev,
                    errors: { ...prev.errors, email: { id: 'forgotPw.invalidEmail' } },
                }));
            }
            else
                Toaster.open({ id: 'forgotPw.general.error' });
        }
    }, []);
    return (React.createElement("div", null,
        React.createElement("p", null, __('forgotPw.info')),
        React.createElement(Form$1, { data: data, validation: validation, onSubmit: _PasswordForgottenForm.onSubmit, onSubmitFailed: onSubmitFailed, onSubmitFinished: onSubmitFinished, onChange: setData },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-xs-12 col-sm-6" },
                    React.createElement(FormInput, { Field: Fields$1.email, name: "email", type: "email", autocomplete: "username", label: "forgotPw.email.label", trim: true, autoFocus: !email }))),
            React.createElement(RequiredInfo, null),
            React.createElement("div", { className: "row buttons" },
                React.createElement("div", { className: "col-xs-12" },
                    React.createElement(FormButtons, { disabled: Morfi.hasErrors(data), submitLabel: "forgotPw.submit.button", loading: data.submitting, onAbort: close }))))));
};

/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */
var Action;

(function (Action) {
  /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */
  Action["Pop"] = "POP";
  /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */

  Action["Push"] = "PUSH";
  /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */

  Action["Replace"] = "REPLACE";
})(Action || (Action = {}));

process.env.NODE_ENV !== "production" ? function (obj) {
  return Object.freeze(obj);
} : function (obj) {
  return obj;
};

/**
 * React Router DOM v6.2.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const _excluded = ["onClick", "reloadDocument", "replace", "state", "target", "to"],
      _excluded2 = ["aria-current", "caseSensitive", "className", "end", "style", "to", "children"];

if (process.env.NODE_ENV !== "production") ;

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The public API for rendering a history-aware <a>.
 */
const Link = /*#__PURE__*/forwardRef(function LinkWithRef(_ref4, ref) {
  let {
    onClick,
    reloadDocument,
    replace = false,
    state,
    target,
    to
  } = _ref4,
      rest = _objectWithoutPropertiesLoose(_ref4, _excluded);

  let href = useHref(to);
  let internalOnClick = useLinkClickHandler(to, {
    replace,
    state,
    target
  });

  function handleClick(event) {
    if (onClick) onClick(event);

    if (!event.defaultPrevented && !reloadDocument) {
      internalOnClick(event);
    }
  }

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    createElement("a", _extends({}, rest, {
      href: href,
      onClick: handleClick,
      ref: ref,
      target: target
    }))
  );
});

if (process.env.NODE_ENV !== "production") {
  Link.displayName = "Link";
}

/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
const NavLink = /*#__PURE__*/forwardRef(function NavLinkWithRef(_ref5, ref) {
  let {
    "aria-current": ariaCurrentProp = "page",
    caseSensitive = false,
    className: classNameProp = "",
    end = false,
    style: styleProp,
    to,
    children
  } = _ref5,
      rest = _objectWithoutPropertiesLoose(_ref5, _excluded2);

  let location = useLocation();
  let path = useResolvedPath(to);
  let locationPathname = location.pathname;
  let toPathname = path.pathname;

  if (!caseSensitive) {
    locationPathname = locationPathname.toLowerCase();
    toPathname = toPathname.toLowerCase();
  }

  let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
  let ariaCurrent = isActive ? ariaCurrentProp : undefined;
  let className;

  if (typeof classNameProp === "function") {
    className = classNameProp({
      isActive
    });
  } else {
    // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [classNameProp, isActive ? "active" : null].filter(Boolean).join(" ");
  }

  let style = typeof styleProp === "function" ? styleProp({
    isActive
  }) : styleProp;
  return /*#__PURE__*/createElement(Link, _extends({}, rest, {
    "aria-current": ariaCurrent,
    className: className,
    ref: ref,
    style: style,
    to: to
  }), typeof children === "function" ? children({
    isActive
  }) : children);
});

if (process.env.NODE_ENV !== "production") {
  NavLink.displayName = "NavLink";
} ////////////////////////////////////////////////////////////////////////////////
// HOOKS
////////////////////////////////////////////////////////////////////////////////

/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */


function useLinkClickHandler(to, _temp) {
  let {
    target,
    replace: replaceProp,
    state
  } = _temp === void 0 ? {} : _temp;
  let navigate = useNavigate();
  let location = useLocation();
  let path = useResolvedPath(to);
  return useCallback(event => {
    if (event.button === 0 && ( // Ignore everything but left clicks
    !target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ) {
      event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
      // a push, so do the same here.

      let replace = !!replaceProp || createPath(location) === createPath(path);
      navigate(to, {
        replace,
        state
      });
    }
  }, [location, navigate, path, replaceProp, state, target, to]);
}

const initialValues = { email: '', password: '', redirectUrl: '' };
const { Form, Fields } = TrackingForm.create(initialValues, TRACK_ID('2019-03-12 10:14:51'));
const validations = {
    email: { onBlur: Validators.email },
    password: { onSubmit: Validators.mandatoryString({ msg: { id: 'login.password.error' } }) },
};
const onSubmit = ({ email, password, redirectUrl }) => AuthService.login(email, password, redirectUrl);
const _openPwForgottenForm = (email) => Modal.open(React.createElement(PasswordForgottenForm, { close: Modal.close, email: Validators.email(email) ? undefined : email }), 'forgotPw.modal.header');
const LoginForm = ({ fixedEmail }) => {
    const navigate = useNavigate();
    const onAbort = useCallback(() => navigate(-1), [navigate]);
    const { search } = useLocation();
    const redirect = UrlUtil.locationSearchToQuery(search)['redirect'];
    const initialFormValues = fixedEmail
        ? { ...initialValues, email: fixedEmail, redirectUrl: redirect }
        : { ...initialValues, redirectUrl: redirect };
    const [data, setData] = useState({ values: initialFormValues, errors: {} });
    const [error, setError] = useState(undefined);
    // every time a user types we want to clear the previous error
    const onChange = useCallback((data) => {
        setData(data);
        setError(undefined);
    }, []);
    const onSubmitFailed = useCallback((error) => {
        if (!Morfi.isValidationError(error)) {
            if (error.errorCode === WsErrorCode.AUTHENTICATION_FAILED) {
                setError({ id: 'login.authentication.failed' });
            }
            else {
                setError({ id: 'login.general.error' });
            }
        }
    }, []);
    const onForgottenPassword = useCallback(() => _openPwForgottenForm(data.values.email), [data.values.email]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "h2" }, __('login.headline')),
        React.createElement(Form, { className: "fullwidth", data: data, validation: validations, onSubmit: onSubmit, onSubmitFailed: onSubmitFailed, onChange: onChange },
            React.createElement(FormInput, { Field: Fields.email, name: "email", type: "email", autocomplete: "username", label: "login.email.label", trim: true, readOnly: !!fixedEmail }),
            React.createElement(FormInput, { Field: Fields.password, name: "password", type: "password", autocomplete: "current-password", label: "login.password.label" }),
            React.createElement(React.Fragment, null, error && React.createElement(DisplayError, { error: error })),
            React.createElement(Button, { className: "btn btn-simple forgotten", onClick: onForgottenPassword, label: "login.passwordForgotten.link", type: "button" }),
            React.createElement(FormButtons, { submitLabel: "login.submit.button", submitClassName: "btn-lg", loading: data.submitting, disabled: Morfi.hasErrors(data) || !!error, onAbort: onAbort, abortLabel: "button.back", abortClassName: "back-btn" }))));
};

addIntlData(intlData);

export { AuthService, CreateAccountForm, CreateAccountOpportunity, EmailAdvertiseInfo, LoginForm, LoginLinks, PasswordForgottenForm, SessionKeepAlive };
